var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("title", [
        _c("h4", { staticClass: "dinlineb mt-0" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Smart-Tags")))
        ])
      ]),
      _vm._v(" "),
      !_vm.loader && !_vm.editMode && _vm.display == "column"
        ? _c(
            "div",
            { staticClass: "dinlineb" },
            [
              _c(
                "link-button",
                {
                  attrs: {
                    permissions: _vm.permissions,
                    "perm-to-check": _vm.permToCheck
                  },
                  on: { clicked: _vm.toggleMode }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.values.length > 0
                          ? _vm.$l10n.__("Modifier")
                          : _vm.$l10n.__("Ajouter")
                      ) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      [
        _vm.editMode
          ? _c(
              "div",
              { staticClass: "prelative wp-10", class: _vm.containerTagClass },
              [
                _c(
                  "el-select",
                  {
                    class: _vm.selectorContainerClass,
                    attrs: {
                      multiple: "",
                      filterable: "",
                      "allow-create": _vm.permissions["can_create"],
                      "default-first-option": "",
                      "collapse-tags": false,
                      placeholder: _vm.$t.__("utilities.Tags.enter_smarttag"),
                      remote: "",
                      "remote-method": _vm.remote,
                      size: _vm.size,
                      "data-bot": "smart-tag__input"
                    },
                    on: { change: _vm.update },
                    model: {
                      value: _vm.values,
                      callback: function($$v) {
                        _vm.values = $$v
                      },
                      expression: "values"
                    }
                  },
                  _vm._l(_vm.tags, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.value, value: item.id }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _vm.standalone && _vm.isInline
                  ? _c(
                      "div",
                      { staticClass: "flex-row ai-center" },
                      [
                        _c("CompassButton", {
                          staticClass: "ml-2",
                          attrs: {
                            label: "Enregistrer",
                            "data-bot": "smart-tags__save"
                          },
                          on: { click: _vm.record }
                        }),
                        _vm._v(" "),
                        _c("CompassIconButton", {
                          staticClass: "ml-2",
                          attrs: {
                            icon: "close",
                            "data-bot": "smart-tags__close"
                          },
                          on: { click: _vm.cancel }
                        })
                      ],
                      1
                    )
                  : _vm.standalone
                  ? _c("div", { staticClass: "aright mt-2" }, [
                      _c("ul", { staticClass: "list-inline" }, [
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "link gray-60",
                              attrs: { href: "javascript:;" },
                              on: { click: _vm.cancel }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$l10n.__("Annuler")) +
                                  "\n                        "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "link",
                              attrs: { href: "javascript:;" },
                              on: { click: _vm.record }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$l10n.__("Valider")) +
                                  "\n                        "
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          : _c(
              "div",
              {
                staticClass: "label-tag flex-row",
                class: _vm.labelTagContainerClass
              },
              [
                !_vm.loader && _vm.tagsStore.length > 0
                  ? _c(
                      "div",
                      { on: { click: _vm.editInPlace } },
                      _vm._l(_vm.tagsStore, function(tag, index) {
                        return _c(
                          "CompassTooltip",
                          {
                            key: index,
                            ref: "tags",
                            refInFor: true,
                            attrs: {
                              content: tag.value,
                              placement: "top",
                              "content-class": "label-tag--tooltip__container"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "label ellipsis",
                                class: _vm.labelTagClass,
                                attrs: {
                                  "data-bot": "smart-tags__tag-" + index
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(tag.value) +
                                    "\n                    "
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInline
                  ? _c("CompassPlainButton", {
                      staticClass: "tag-save",
                      attrs: {
                        label: _vm.$t.__("common.labels.smart_tags"),
                        variant: "neutral",
                        leftIcon: "edit",
                        "data-bot": "smart-tags__link"
                      },
                      on: { click: _vm.editTags }
                    })
                  : _vm._e()
              ],
              1
            )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }